import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import { TIPO_FILTRO_ORDINE, TipoFiltroOrdine} from '../../../_helpers/TipoFiltroOrdine';

@Component({
    selector: 'app-select-type-filtro-ordine',
    templateUrl: './select-type-filtro-ordine.component.html',
    styleUrls: ['./select-type-filtro-ordine.component.scss'],
    standalone: false
})
export class SelectTypeFiltroOrdineComponent {
  @Input() tipoFiltroOrdine: TipoFiltroOrdine;
  @Output() tipoFiltroOrdineChange = new EventEmitter<TipoFiltroOrdine>();
  tipoFiltroOrdinesItem = TIPO_FILTRO_ORDINE;
  selectTipoFiltroOrdine = (e: SelectCustomEvent) => this.tipoFiltroOrdineChange.emit(e.target.value);
}
